import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import gmailApi from 'src/api/gmail';

const GoogleCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(`Authorization failed: ${errorParam}`);
        setTimeout(() => navigate('/dashboard/send-email'), 3000);
        return;
      }

      if (!code) {
        setError('No authorization code received');
        setTimeout(() => navigate('/dashboard/send-email'), 3000);
        return;
      }

      try {
        const result = await gmailApi.handleCallback(code);

        if (result.success) {
          // Redirect back to send-email page with success
          navigate('/dashboard/send-email?gmail_connected=true');
        } else {
          setError(result.error || 'Failed to complete authorization');
          setTimeout(() => navigate('/dashboard/send-email'), 5000);
        }
      } catch (err: any) {
        console.error('OAuth callback error:', err);
        setError(err?.message || 'An error occurred during authorization');
        setTimeout(() => navigate('/dashboard/send-email'), 5000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        p: 3,
      }}
    >
      {error ? (
        <>
          <Alert severity="error"
sx={{ maxWidth: 400 }}>
            {error}
          </Alert>
          <Typography variant="body2"
color="text.secondary">
            Redirecting back to email page...
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress size={48} />
          <Typography variant="h6">
            Connecting your Gmail account...
          </Typography>
          <Typography variant="body2"
color="text.secondary">
            Please wait while we complete the authorization.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default GoogleCallbackPage;
